module.exports = __webpack_public_path__ + "img/nav-settings.66904699.svg";